<template>
	<div>
		<div v-html="privacy_policy"></div>
	</div>	
</template>
<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('about', ['privacy_policy'])
  },
  data: () => ({
    content: null
  }),
  created () {
    this.$vs.loading()
    this.$store.dispatch('about/index')
      .then(() => {
        this.$vs.loading.close()
      })
      .catch(e => {
        this.$vs.loading.close()
        if (e.response) console.error(e.response)

        return false
      })
  }
}
</script>